import React from 'react';
import { connect } from 'react-redux';

import { DISTANCE, WEIGHT, TEMPERATURE, STRENGTH, MOMENT, LOAD, AREA } from '@reducers/units';

import {
  setDistanceUnit,
  setWeightUnit,
  setTemperatureUnit,
  setStrengthUnit,
  setMomentUnit,
  setLoadUnit,
  setAreaUnit
} from '@reducers/actions';
import { APP_TEXTS } from '../../texts/texts';

// eslint-disable-next-line react/prefer-stateless-function
class UnitsForm extends React.Component {

  render() {
    return (
      <form className="options__units-form">
        <div>
          <label 
            htmlFor="load" 
            className={`d-flex justify-content-between align-items-center` + 
                      (!this.props.isUnitRow && ` GeneralSettings__select-holder mt-2`)}
          >
            <span>{APP_TEXTS.LOAD_LABEL.Content}</span>
            <select
              value={this.props.load}
              onChange={e => this.props.setLoadUnit(e.target.value)}
              id="load"
              className="form-control"
            >
              <option value={LOAD.KILONEWTON}>{APP_TEXTS.KILONEWTON.Content}</option>
              <option value={LOAD.NEWTON}>{APP_TEXTS.NEWTON.Content}</option>
              <option value={LOAD.DECANEWTON}>{APP_TEXTS.DECANEWTON.Content}</option>
              <option value={LOAD.POUND_FORCE}>{APP_TEXTS.POUND_FORCE.Content}</option>
            </select>
          </label>
        </div>

        <div>
          <label 
            htmlFor="moment" 
            className={`d-flex justify-content-between align-items-center` + 
                      (!this.props.isUnitRow && ` GeneralSettings__select-holder mt-2`)}
          >
            <span>{APP_TEXTS.MOMENT_LABEL.Content}</span>
            <select
              value={this.props.moment}
              onChange={e => this.props.setMomentUnit(e.target.value)}
              id="moment"
              className="form-control"
            >
              <option value={MOMENT.NEWTON_METERS}>{APP_TEXTS.NEWTON_METER.Content}</option>
              <option value={MOMENT.KILONEWTON_METER}>{APP_TEXTS.KILONEWTON_METER.Content}</option>
              <option value={MOMENT.DECANEWTON_METER}>{APP_TEXTS.DECANEWTON_METER.Content}</option>
              <option value={MOMENT.FOOT_POUND_FORCE}>{APP_TEXTS.FOOT_POUND_FORCE.Content}</option>
            </select>
          </label>
        </div>

        <div>
          <label 
            htmlFor="strength" 
            className={`d-flex justify-content-between align-items-center` + 
                      (!this.props.isUnitRow && ` GeneralSettings__select-holder mt-2`)}
          >
            <span>{APP_TEXTS.STRENGTH_LABEL.Content}</span>
            <select
              value={this.props.strength}
              onChange={e => this.props.setStrengthUnit(e.target.value)}
              id="strength"
              className="form-control"
            >
              <option value={STRENGTH.POUND_PER_SQUARE_INCH}>{APP_TEXTS.POUND_PER_SQUARE_INCH.Content}</option>
              <option value={STRENGTH.NEWTON_SQUARE_MILLIMETERS}>{APP_TEXTS.NEWTON_SQUARE_MILLIMETERS.Content}</option>
            </select>
          </label>
        </div>

        <div>
          <label 
            htmlFor="distance" 
            className={`d-flex justify-content-between align-items-center` + 
                      (!this.props.isUnitRow && ` GeneralSettings__select-holder mt-2`)}
          >
            <span>{APP_TEXTS.DISTANCE_LABEL.Content}</span>
            <select
              value={this.props.distance}
              onChange={e => this.props.setDistanceUnit(e.target.value)}
              id="distance"
              className="form-control"
            >
              <option value={DISTANCE.CENTIMETERS}>{APP_TEXTS.CENTIMETERS.Content}</option>
              <option value={DISTANCE.MILLIMETERS}>{APP_TEXTS.MILLIMETERS.Content}</option>
              <option value={DISTANCE.INCHES}>{APP_TEXTS.INCHES.Content}</option>
            </select>
          </label>
        </div>

        <div>
          <label 
            htmlFor="area" 
            className={`d-flex justify-content-between align-items-center` + 
                      (!this.props.isUnitRow && ` GeneralSettings__select-holder mt-2`)}
          >
            <span>{APP_TEXTS.AREA_LABEL.Content}</span>
            <select
              value={this.props.area}
              onChange={e => this.props.setAreaUnit(e.target.value)}
              id="area"
              className="form-control"
            >
              <option value={AREA.SQUARE_MILLIMETERS}>{APP_TEXTS.SQUARE_MILLIMETERS.Content}</option>
              <option value={AREA.SQUARE_CENTIMETERS}>{APP_TEXTS.SQUARE_CENTIMETERS.Content}</option>
              <option value={AREA.SQUARE_INCHES}>{APP_TEXTS.SQUARE_INCHES.Content}</option>
            </select>
          </label>
        </div>

        <div>
          <label 
            htmlFor="weight" 
            className={`d-flex justify-content-between align-items-center` + 
                      (!this.props.isUnitRow && ` GeneralSettings__select-holder mt-2`)}
          >
            <span>{APP_TEXTS.WEIGHT_LABEL.Content}</span>
            <select
              value={this.props.weight}
              onChange={e => this.props.setWeightUnit(e.target.value)}
              id="weight"
              className="form-control"
            >
              <option value={WEIGHT.KILOGRAM}>{APP_TEXTS.KILOGRAM.Content}</option>
              <option value={WEIGHT.GRAM}>{APP_TEXTS.GRAM.Content}</option>
              <option value={WEIGHT.POUND}>{APP_TEXTS.POUND.Content}</option>
            </select>
          </label>
        </div>

        <div>
          <label 
            htmlFor="temperature" 
            className={`d-flex justify-content-between align-items-center` + 
                      (!this.props.isUnitRow && ` GeneralSettings__select-holder mt-2`)}
          >
            <span>{APP_TEXTS.TEMPERATURE_LABEL.Content}</span>
            <select
              value={this.props.temperature}
              onChange={e => this.props.setTemperatureUnit(e.target.value)}
              id="temperature"
              className="form-control"
            >
              <option value={TEMPERATURE.FAHRENHEIT}>{APP_TEXTS.FAHRENHEIT.Content}</option>
              <option value={TEMPERATURE.CELSIUS}>{APP_TEXTS.CELSIUS.Content}</option>
            </select>
          </label>
        </div>
      </form>
    );
  }

}

const mapState = state => ({
  distance: state.main.units.distance,
  weight: state.main.units.weight,
  temperature: state.main.units.temperature,
  strength: state.main.units.strength,
  moment: state.main.units.moment,
  load: state.main.units.load,
  area: state.main.units.area
});

const mapDispatch = dispatch => ({
  setDistanceUnit: value => dispatch(setDistanceUnit(value)),
  setWeightUnit: value => dispatch(setWeightUnit(value)),
  setTemperatureUnit: value => dispatch(setTemperatureUnit(value)),
  setStrengthUnit: value => dispatch(setStrengthUnit(value)),
  setMomentUnit: value => dispatch(setMomentUnit(value)),
  setLoadUnit: value => dispatch(setLoadUnit(value)),
  setAreaUnit: value => dispatch(setAreaUnit(value))
});

export default connect(mapState, mapDispatch)(UnitsForm);



// WEBPACK FOOTER //
// ./src/components/UnitsForm/index.js